/**
 * Toast notification wrapper using react-toastify.
 * Usage:
 *   import toast from '../../utils/toast';
 *   toast.success('Thành công!');
 *   toast.error('Có lỗi xảy ra!');
 *   toast.warning('Cảnh báo');
 *   toast.info('Thông tin');
 */
import { toast } from 'react-toastify';

export default toast;
